import { FC, ReactNode } from 'react';

import RightArrow from '@/assets/right-arrow.svg';

export interface ButtonElementProps {
  children?: ReactNode;
  url?: string;
  style?: string;
  color?: string;
  className?: string;
  link?: object;
  form?: boolean;
  target?: string;
}

const BUTTON_COLOR = {
  base: '',
  accent: 'text-lift-red text-projectAccent',
};

const ButtonElement: FC<ButtonElementProps> = ({
  children,
  color = 'base',
  className,
}) => {
  const buttonColor = BUTTON_COLOR[color];

  return (
    <span
      className={`grid bg-theme-charcoal font-medium uppercase text-white tracking-[0.2rem] overflow-hidden rounded-full border border-transparent cursor-pointer h-10 w-10 space-x-2  ${buttonColor} ${className}`}
    >
      <span className="justify-left absolute flex w-full items-center self-center whitespace-nowrap align-middle">
        <img src={RightArrow.src} className="mx-5 h-3 w-3" />
        {children}
      </span>
    </span>
  );
};

export default ButtonElement;
